<div class="kontakt-dialog p-8">
  <mm-przycisk-ikona class="przycisk-zamknij"
                      ikona="zamknij"
                      typ="przezroczysty"
                      label="{{'codes.generyczne.etykieta-zamknij' | translate}}"
                      (click)="zamknijDialog()">
  </mm-przycisk-ikona>
  <mm-kontakt-formularz (poWyslaniu)="zamknijDialog()"></mm-kontakt-formularz>
</div>

